export const isEnterKey = (event: React.KeyboardEvent): boolean =>
    event.key === 'Enter' || event.key === 'NumpadEnter';
